import React, {useEffect} from 'react';
import './App.css'
import HomeFeatured from './components/home/home-featured'
import HomeMission from './components/home/home-mission'
import HomeSolutions from './components/home/home-solutions'
import HomeWork from './components/home/home-work'
import HomeClients from './components/home/home-clients'
import HomeConnect from './components/home/home-connect'
import AOS from "aos";
import "aos/dist/aos.css";


function Home() {
useEffect(() => {
  AOS.init({duration: 1000});
  window.scrollTo(0, 0);
}, []);

  return (
     <>
   <HomeFeatured />
   <div data-aos="fade-up"><HomeMission /></div>
   <div data-aos="fade-up"><HomeSolutions /></div>
   <div data-aos="fade-up"><HomeWork /></div>
   <div data-aos="fade-up"><HomeClients /></div>
   <div data-aos="fade-up"><HomeConnect /></div>
   </>
  );
};

export default Home;
